import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Operations } from '../../../../interface/company-client.interface';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { environment } from 'src/environments/enviroments';

@Component({
  selector: 'app-approved-operations',
  templateUrl: './approved-operations.component.html',
  styleUrls: ['./approved-operations.component.scss'],
})
export class ApprovedOperationsComponent {
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(CdkContextMenuTrigger)
  menu!: CdkContextMenuTrigger;
  @Input() operations: Operations[];
  @Input() operationsApproved: Operations[];
  @Input() companyId: number;

  public dataSource!: MatTableDataSource<Operations>;
  public existenDatos: boolean = true;
  public rutCompany: number;
  public displayedColumns: string[] = [
    'folio',
    'idMinute',
    'fechaCesion',
    'createdAt',
    'rate',
    'allInRate',
    'dateAcept',
    'financedAmount',
    'downPaymentPercentage',
    'operationState',
    'transferAmount',
    'plazo',
    'comments',
    'executiveName',
    'lastUpdate',
  ];

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.dataSource = new MatTableDataSource<Operations>([]);
  }

  ngOnInit() {
    this.setDataSource();
  }

  setDataSource() {
    this.dataSource.data = this.operationsApproved;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public redirectMinute(minuteRequestId: number) {
    if (minuteRequestId <= environment.nminutelimitold) {
      this.redirectToOldMinute(minuteRequestId);
    } else {
      this.redirectToNewMinute(minuteRequestId);
    }
  }

  public redirectToOldMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/old-minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }

  public redirectToNewMinute(minuteRequestId: number) {
    this.router.navigate(['dashboards/minute'], {
      queryParams: { id: +minuteRequestId },
    });
  }
}
